import PrivateRoute from 'utils/privateRoute';
import PowerBIUserActivityDashboard from 'components/PowerBIObservability/PowerBIUserActivityDashboard';

const PowerBIObsRoutes = [
	{
		key: 'power_user_activity_dash',
		route: '/powerBI/userActivity/*',
		component: (
			<PrivateRoute
				Component={PowerBIUserActivityDashboard}
				restrictedRoles={['Data Operations Admin', 'Data Operations User', 'D&AI Executive User', 'Program Executive']}
			/>
		)
	},
];

export default PowerBIObsRoutes;
